// TREVA tabs. A [data-tv-tabs] wrapper holds tabs [data-tv-tab=key] and panels [data-tv-panel=key].
// Several panels can share one key, which is how the FAQ categories filter their questions.
(() => {
  const show = (tab) => {
    const root = tab.closest('[data-tv-tabs]');
    const key = tab.dataset.tvTab;
    root.querySelectorAll('[data-tv-tab]').forEach((t) => t.setAttribute('aria-selected', t === tab));
    root.querySelectorAll('[data-tv-panel]').forEach((p) => { p.hidden = p.dataset.tvPanel !== key; });
  };
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-tv-tab]');
    if (tab) show(tab);
  });
  // Theme editor: selecting a block in the sidebar opens its panel.
  document.addEventListener('shopify:block:select', (e) => {
    const panel = e.target.closest('[data-tv-panel]');
    const tab = panel && panel.closest('[data-tv-tabs]').querySelector(`[data-tv-tab="${panel.dataset.tvPanel}"]`);
    if (tab) show(tab);
  });
})();
